import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

class ModalV2 extends React.PureComponent {
  static get displayName() {
    return "ModalV2";
  }

  static get propTypes() {
    return {
      show: PropTypes.bool,
      title: PropTypes.string,
      children: PropTypes.node,
      onHide: PropTypes.func,
      buttonLabel: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      show: false,
      title: "",
    };
  }

  render() {
    const { children, show, title, onHide } = this.props;

    return (
      <Modal className="dialog-modal" show={show} onHide={onHide}>
        <Modal.Header>
          <Row className="w-100">
            <Col xs={8}>
              <Modal.Title>{title}</Modal.Title>
            </Col>
            <Col xs={4}>
              <Button onClick={onHide} className="pull-right" variant="secondary">
                Close
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    );
  }
}

export { ModalV2 };
